import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const PasswordInput = ({
    name,
    placeholder,
    value,
    onChange: handleChange,
    isInvalid,
    size,
    autoComplete,
    errorMsg,
    hasValidation = true,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <InputGroup className="c-input-group-control-borders" size={size} hasValidation={hasValidation}>
            <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={handleChange}
                isInvalid={isInvalid}
                size={size}
                autoComplete={autoComplete}
            />
            <InputGroup.Text className="bg-light" onClick={togglePasswordVisibility} role="button">
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} size="2xs" />
            </InputGroup.Text>
            {hasValidation && <Form.Control.Feedback type="invalid">{errorMsg}</Form.Control.Feedback>}{' '}
        </InputGroup>
    );
};

export default PasswordInput;
